import { useState } from 'react';

function EquityMarketEssentialsModule() {
  const [openModule, setOpenModule] = useState(null);

  const toggleModule = (index) => {
    setOpenModule(openModule === index ? null : index);
  };

  const modules = [
    {
      title: "Module 1: Introduction to Stocks",
      content: [
        "What is a Stock/Share?",
        "Definition and ownership.",
        "Rights of shareholders (dividends, voting)."
      ]
    },
    {
      title: "Module 2: Motivation to Learn",
      content: [
        "Why Do You Want to Learn the Stock Market?",
        "Wealth creation opportunities.",
        "Financial literacy and informed decision-making.",
        "Understanding market dynamics and economic indicators."
      ]
    },
    {
      title: "Module 3: Types of Markets",
      content: [
        "Equity Market Types",
        "Primary Market: Role in raising capital and how Initial Public Offerings (IPOs) work.",
        "Secondary Market: How stocks are traded between investors on stock exchanges.",
        "Over-the-Counter (OTC) Market: Introduction to OTC trading and its significance.",
        "Stock Exchanges: Overview of major stock exchanges (NSE, BSE) and their roles."
      ]
    },
    {
      title: "Module 4: Equity Trading Basics",
      content: [
        "How to Trade in Equity",
        "Steps to open a brokerage account.",
        "Types of orders (market orders, limit orders, stop-loss orders).",
        "Importance of research and analysis."
      ]
    },
    {
      title: "Module 5: Investment Strategies",
      content: [
        "Investment Types",
        "Long-term vs. short-term investments.",
        "Dividend investing, growth investing, and value investing."
      ]
    },
    {
      title: "Module 6: Risk Management",
      content: [
        "Managing Investment Risks",
        "Diversification: Benefits and how to diversify.",
        "Setting stop-loss and take-profit levels.",
        "Risk-to-reward ratio and position sizing."
      ]
    },
    {
      title: "Module 7: Technical Analysis Basics",
      content: [
        "Introduction to Chart Reading",
        "Types of charts (candlestick, bar, line).",
        "Key patterns (head and shoulders, triangles).",
        "Support and resistance levels."
      ]
    },
    {
      title: "Module 8: Fundamental Analysis Basics",
      content: [
        "Evaluating Company Health",
        "Reading financial statements (income statement, balance sheet, cash flow).",
        "Key financial ratios (P/E ratio, debt-to-equity).",
        "Understanding economic indicators and their impact."
      ]
    },
    {
      title: "Module 9: Psychology of Trading",
      content: [
        "Mindset and Emotions",
        "Managing emotions in trading.",
        "Avoiding common biases (confirmation bias, overconfidence).",
        "Developing a disciplined approach."
      ]
    },
    {
      title: "Module 10: Building a Portfolio",
      content: [
        "Constructing a Balanced Portfolio",
        "Asset allocation for different financial goals.",
        "Rebalancing and monitoring your portfolio.",
        "Aligning investments with risk tolerance and timeline."
      ]
    },
    {
      title: "Module 11: Understanding Market Regulations",
      content: [
        "Compliance and Legalities",
        "Overview of regulatory bodies (SEBI, RBI).",
        "Investor rights and protections.",
        "Market compliance essentials."
      ]
    }
  ];

  return (
    <div className="container-fluid">
      <div className="container">
        <h1 className="text-center py-5">Our Course Curriculum</h1>
        <div className="row justify-content-center">
          {modules.map((module, index) => (
            <div
              key={index}
              className="col-12 col-md-5 mb-3 d-flex flex-column align-items-center"
              style={{ marginBottom: '10px' }}
            >
              {/* Accordion Heading */}
              <div
                className="w-100 p-3 d-flex justify-content-between align-items-center"
                style={{
                  backgroundColor: '#f8f9fa',
                  border: '1px solid #ddd',
                  cursor: 'pointer'
                }}
                onClick={() => toggleModule(index)}
              >
                <h5 className="m-0">{module.title}</h5>
                <span
                  style={{
                    fontSize: '18px',
                    transform: openModule === index ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s'
                  }}
                >
                  ▼
                </span>
              </div>

              {/* Accordion Content */}
              {openModule === index && (
                <div
                  className="w-100 p-3"
                  style={{
                    border: '1px solid #ddd',
                    borderTop: 'none',
                    backgroundColor: '#ffffff'
                  }}
                >
                  {module.content.map((item, itemIndex) => (
                    <div
                      key={itemIndex}
                      className="d-flex align-items-center mb-2"
                      style={{
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        padding: '8px',
                        backgroundColor: '#fdfdfd'
                      }}
                    >
                      <span style={{ color: '#007bff', marginRight: '8px' }}>➤</span>
                      <p className="m-0" style={{ fontSize: '14px', color: '#333' }}>
                        {item}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default EquityMarketEssentialsModule;
